import { DateTime } from "luxon";
import { RRule } from "rrule";
import { SpecialOpeningHour } from "@/app/lib/generated/graphql-types";

export function nextOccurrence(reoccurringEvent: SpecialOpeningHour): Date | null {
    if (reoccurringEvent.recurrenceRule) {
        return RRule
            .fromString(reoccurringEvent.recurrenceRule)
            .after(new Date(), true);
    } else {
        if (DateTime.fromISO(reoccurringEvent.startDate) >= DateTime.now()) {
            return new Date(reoccurringEvent.startDate);
        }
        return null;
    }
}
